import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
} from 'antd';
import React from 'react';

const links = [
  {
    name: 'Youtube',
    value: 'youtube',
  },
  {
    name: 'Facebook',
    value: 'facebook',
  },
  {
    name: 'Instagram',
    value: 'instagram',
  },
];

const { Option } = Select;
const { Text } = Typography;

function CreationsEdit(props) {
  const { isOpen, toggle, initialValues, onSubmit, status } = props;

  const linkTypeMenu = links.map((link) => (
    <Option key={link.name} value={link.value}>
      {link.name}
    </Option>
  ));

  return (
    <Modal
      title={props.type === 'ADD' ? 'Add Creation info' : 'Edit Creation info'}
      visible={isOpen}
      footer={null}
      onCancel={toggle}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 14 }}
          onFinish={onSubmit}
          initialValues={initialValues}
        >
          <Form.Item
            label="Type"
            name={['widget', 'type']}
            rules={[{ required: true, message: 'Please input type!' }]}
          >
            <Select placeholder="Select a link type">{linkTypeMenu}</Select>
          </Form.Item>
          <Form.Item
            label="Title"
            name="title"
            rules={[
              { required: true, message: 'Please input title!' },
              {
                max: 100,
                message: 'Title cannot be more than 100 characters!',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Link"
            name={['widget', 'link']}
            rules={[{ required: true, message: 'Please input link!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[
              { required: true, message: 'Please input description!' },
              {
                max: 250,
                message: 'Description cannot be more than 250 characters!',
              },
            ]}
          >
            <Input />
          </Form.Item>
          {status.type === 'ERROR' ? (
            <Text type="danger">{status.message}</Text>
          ) : null}
          {status.type === 'SUCCESS' ? (
            <Text type="success">Sucessfully Updated!</Text>
          ) : null}
          <Row justify="end">
            <Col>
              <Button type="primary" htmlType="submit">
                {props.type === 'ADD' ? 'Add' : 'Update'}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
}

export default CreationsEdit;
